/**
 * ICH eCTD module catalog. Used in module-picker dropdowns and as the
 * `Document.ModuleNumber` validation set. Mirrors `src/lib/ectd/module-mapping.ts`
 * on the backend.
 */

export const CTD_MODULES = ['1', '2', '3', '4', '5'] as const;
export type CtdModule = (typeof CTD_MODULES)[number];

export const MODULE_LABELS: Readonly<Record<CtdModule, string>> = Object.freeze({
  '1': 'Module 1 — Administrative',
  '2': 'Module 2 — Summaries',
  '3': 'Module 3 — Quality',
  '4': 'Module 4 — Nonclinical Reports',
  '5': 'Module 5 — Clinical Reports',
});

export const LIFECYCLE_OPERATIONS = ['new', 'replace', 'append', 'delete'] as const;
export type LifecycleOperation = (typeof LIFECYCLE_OPERATIONS)[number];

export const FDA_PATHWAYS = [
  '505(b)(1)',
  '505(b)(2)',
  '505(j)',
  '351(a)',
  '351(k)',
] as const;

export const EMA_PROCEDURES = [
  'Centralised',
  'Mutual Recognition',
  'Decentralised',
  'National',
] as const;

export const FDA_SUBMISSION_TYPES = ['NDA', 'ANDA', 'BLA', 'IND'] as const;

export const EMA_SUBMISSION_TYPES = [
  'MAA',
  'Variation',
  'PSUR',
  'RMP',
  'AnnexII',
  'Renewal',
  'Withdrawal',
  'PASS',
] as const;

export const HC_SUBMISSION_TYPES = [
  'NDS',
  'ANDS',
  'SNDS',
  'SNDS-C',
  'NC',
  'NC-C',
  'DIN-A',
  'MF',
] as const;
